/*
 * Newsletter + pixel tracking consent.
 * Al submit di un form newsletter che contiene [data-newsletter-consent],
 * invia la scelta al webhook n8n (email, trackingConsent, market, source).
 * Invio tramite sendBeacon (text/plain -> nessun preflight CORS, sopravvive
 * alla navigazione del submit nativo); fallback fetch keepalive.
 * Il blocco del submit quando la checkbox obbligatoria non e' spuntata e'
 * gestito nativamente dall'attributo `required`.
 */
(function () {
  var cfg = window.nlConsentConfig || {};
  if (!cfg.enabled || !cfg.webhook) return;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function send(payload) {
    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon(cfg.webhook, blob)) return;
      }
    } catch (e) {}
    try {
      fetch(cfg.webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: body,
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  function wire(form) {
    if (form.__nlConsentWired) return;
    if (!form.querySelector('[data-newsletter-consent]')) return;
    form.__nlConsentWired = true;

    form.addEventListener('submit', function () {
      // Invia solo se il form e' realmente valido (required consent + email).
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
      var emailEl = form.querySelector('input[type="email"]');
      var email = emailEl ? (emailEl.value || '').trim() : '';
      if (!EMAIL_RE.test(email)) return;
      var trackEl = form.querySelector('[data-nl-tracking]');
      var trackingConsent = trackEl ? !!trackEl.checked : false;
      send({
        email: email,
        trackingConsent: trackingConsent,
        market: cfg.market || '',
        source: 'signup',
        secret: cfg.secret || ''
      });
    });
  }

  function init() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('[data-newsletter-consent]')) wire(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
